import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-deda065a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex space-x-2" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Filter by Business", -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Diamond Whites", -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Smile2Impress", -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Diamond Whites + Smile2Impress", -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Select Dates", -1));
const _hoisted_10 = { class: "flex-1 font-semibold justify-self-start text-3xl" };
const _hoisted_11 = {
    key: 1,
    class: "dashboard-container"
};
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-7 gap-4" };
const _hoisted_13 = { class: "segment statistic" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Total Bookings", -1));
const _hoisted_15 = { class: "segment statistic" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Complete Bookings", -1));
const _hoisted_17 = { class: "segment statistic" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Cancelled Bookings", -1));
const _hoisted_19 = { class: "segment statistic" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Abandoned Checkouts", -1));
const _hoisted_21 = { class: "segment statistic" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "No-Show Rate", -1));
const _hoisted_23 = { class: "segment statistic" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Cancel Rate", -1));
const _hoisted_25 = { class: "segment statistic" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Average Wait", -1));
const _hoisted_27 = { class: "grid grid-col-1 md:grid-cols-3 gap-4" };
const _hoisted_28 = { class: "segment statistic" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Average Distance Travelled", -1));
const _hoisted_30 = { class: "segment statistic" };
const _hoisted_31 = { class: "segment statistic" };
const _hoisted_32 = { class: "grid grid-col-1 md:grid-cols-4 gap-4" };
const _hoisted_33 = { class: "segment statistic" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Average Quoted Distance", -1));
const _hoisted_35 = { class: "segment statistic" };
const _hoisted_36 = { class: "segment statistic" };
const _hoisted_37 = { class: "segment statistic" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Looked But Didn't Checkout", -1));
const _hoisted_39 = { class: "grid grid-col-1 md:grid-cols-3 gap-4" };
const _hoisted_40 = { class: "segment md:col-span-2" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Customer Locations Heatmap", -1));
const _hoisted_42 = { class: "segment" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Requested Counties", -1));
const _hoisted_44 = { class: "segment" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Availability & Conversion", -1));
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Location"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Bookings"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Available Timeslots"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Total Timeslots"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Days"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Average Daily Bookings"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Looked But Didn't book"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Average Wait (Days)"),
        /*#__PURE__*/ _createElementVNode("th", { class: "hover:cursor-pointer" }, "Conversion Rate")
    ])
], -1));
const _hoisted_47 = { class: "col-span-2 pt-4" };
const _hoisted_48 = { class: "text-center pt-4" };
const _hoisted_49 = { class: "text-center pt-4" };
const _hoisted_50 = { class: "text-center pt-4" };
const _hoisted_51 = { class: "text-center pt-4" };
const _hoisted_52 = { class: "text-center pt-4" };
const _hoisted_53 = { class: "text-right pt-4" };
import { CalendarIcon } from "@heroicons/vue/outline";
import { useAuthentication } from "@/stores/authentication";
import { useDashboard } from "@/stores/dashboard";
import { useErrorHandling, useFetch } from "@/helpers";
import Page from "@/components/Page.vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import Loading from "@/components/Loading.vue";
import Button from "@/components/Button.vue";
import ModalDatePicker from "@/views/Dashboard/ModalDatePicker.vue";
import { reactive, ref, watch } from "vue";
import moment from "moment";
import { DoughnutChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";
import counties from "@/conties";
import DataTable from 'datatables.net-vue3';
import DropdownButton from "@/components/DropdownButton.vue";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        Chart.register(...registerables);
        const { handleError } = useErrorHandling();
        const route = useRoute();
        const router = useRouter();
        const { hasPermission } = useAuthentication();
        const { stats, heatmap } = storeToRefs(useDashboard());
        const { fetchStats, fetchHeatmap } = useDashboard();
        const mapContainer = ref();
        const orgFilter = ref('all');
        const datePickModal = ref(false);
        const showDatePickModal = () => (datePickModal.value = true);
        const form = reactive({
            starts: moment().subtract(30, "days").toDate(),
            ends: moment().toDate(),
        });
        const suggestedLocationsData = ref({
            labels: [],
            datasets: [
                {
                    data: [],
                    backgroundColor: [
                        "#25CCF7", "#FD7272", "#54a0ff", "#00d2d3",
                        "#1abc9c", "#2ecc71", "#3498db", "#9b59b6",
                        "#f1c40f", "#e67e22", "#e74c3c", "#d63031",
                        "#5f27cd", "#01a3a4"
                    ].sort((a, b) => 0.5 - Math.random())
                },
            ],
        });
        const averageWaitTime = ref({
            total: 0,
            amount: 0
        });
        function getCountyByID(lookup) {
            for (const county of counties) {
                if (lookup == county.abbreviation)
                    return county.name;
            }
            return false;
        }
        watch(orgFilter, () => {
            fetch();
        });
        const { loading, fetch } = useFetch(async () => {
            if (!hasPermission('manage bookings')) {
                return router.push('/bookings');
            }
            await fetchStats(form.starts, form.ends, orgFilter.value);
            await fetchHeatmap(form.starts, form.ends, orgFilter.value);
            suggestedLocationsData.value.labels = [];
            suggestedLocationsData.value.datasets[0].data = [];
            stats.value.suggested_locations.forEach(stat => {
                let name = getCountyByID(stat.county);
                if (!name)
                    return; // Someone sent us false data?
                suggestedLocationsData.value.labels.push(name);
                suggestedLocationsData.value.datasets[0].data.push(stat.quantity);
            });
            averageWaitTime.value = {
                total: 0,
                amount: 0
            };
            for (const location in stats.value.locations) {
                let wait = stats.value.locations[location].average_wait;
                if (!wait)
                    continue;
                averageWaitTime.value.total += parseInt(wait);
                ++averageWaitTime.value.amount;
            }
        });
        fetch();
        return (_ctx, _cache) => {
            const _component_vue_google_heatmap = _resolveComponent("vue-google-heatmap");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(Page, { "has-header": "" }, {
                    "header:filters": _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createVNode(DropdownButton, { class: "w-full" }, {
                                    menu: _withCtx(() => [
                                        _createElementVNode("a", {
                                            class: "dropdown-option",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (orgFilter.value = 'diamond_whites'))
                                        }, _hoisted_4),
                                        _createElementVNode("a", {
                                            class: "dropdown-option",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (orgFilter.value = 'impress'))
                                        }, _hoisted_6),
                                        _createElementVNode("a", {
                                            class: "dropdown-option",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (orgFilter.value = 'all'))
                                        }, _hoisted_8)
                                    ]),
                                    default: _withCtx(() => [
                                        _hoisted_2
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", null, [
                                _createVNode(Button, {
                                    variant: "grey",
                                    onClickPassive: showDatePickModal
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(CalendarIcon), { class: "icon" }),
                                        _hoisted_9
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    "header:title": _withCtx(() => [
                        _createElementVNode("p", _hoisted_10, "Dashboard (" + _toDisplayString(_unref(moment)(_unref(form).starts).format('DD/MM/YYYY')) + " - " + _toDisplayString(_unref(moment)(_unref(form).ends).format('DD/MM/YYYY')) + ") - " + _toDisplayString((orgFilter.value == 'diamond_whites') ? 'Diamond Whites' : ((orgFilter.value == 'impress') ? 'Smile2Impress' : 'All')), 1)
                    ]),
                    default: _withCtx(() => [
                        (_unref(loading) || !_unref(stats)?.all || !_unref(hasPermission)('manage bookings'))
                            ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("a", null, _toDisplayString(_unref(stats).all.total.toLocaleString('en-UK')), 1),
                                        _hoisted_14
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("a", null, _toDisplayString(_unref(stats).all.total_marked.toLocaleString('en-UK')), 1),
                                        _hoisted_16
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("a", null, _toDisplayString(_unref(stats).all.cancelled.toLocaleString('en-UK')), 1),
                                        _hoisted_18
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("a", null, _toDisplayString(_unref(stats).all.checkout_abandoned.toLocaleString('en-UK')), 1),
                                        _hoisted_20
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round((!isNaN(_unref(stats).all.noshow / _unref(stats).all.total_marked) ? (_unref(stats).all.noshow / _unref(stats).all.total_marked) : 0) * 100)) + "%", 1),
                                        _hoisted_22
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round((!isNaN(_unref(stats).all.cancelled / _unref(stats).all.total) ? (_unref(stats).all.cancelled / _unref(stats).all.total) : 0) * 100)) + "%", 1),
                                        _hoisted_24
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round((averageWaitTime.value.total / averageWaitTime.value.amount) / 60 / 60 / 24)) + " Days", 1),
                                        _hoisted_26
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.average_distance * 10) / 10) + " Miles", 1),
                                        _hoisted_29
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.longest_distance.distance * 10) / 10) + " Miles", 1),
                                        _createElementVNode("h2", null, "Longest Distance Travelled (" + _toDisplayString(_unref(stats).all.longest_distance.location.name) + ")", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.shortest_distance.distance * 10) / 10) + " Miles", 1),
                                        _createElementVNode("h2", null, "Shortest Distance Travelled (" + _toDisplayString(_unref(stats).all.shortest_distance.location.name) + ")", 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.average_quoted_distance * 10) / 10) + " Miles", 1),
                                        _hoisted_34
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.longest_quoted_distance.distance * 10) / 10) + " Miles", 1),
                                        _createElementVNode("h2", null, "Longest Quoted Distance (" + _toDisplayString(_unref(stats).all.longest_quoted_distance.postcode) + " | " + _toDisplayString(_unref(stats).all.longest_quoted_distance.location.name) + ")", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("a", null, _toDisplayString(Math.round(_unref(stats).all.shortest_quoted_distance.distance * 10) / 10) + " Miles", 1),
                                        _createElementVNode("h2", null, "Shortest Quoted Distance (" + _toDisplayString(_unref(stats).all.shortest_quoted_distance.postcode) + " | " + _toDisplayString(_unref(stats).all.shortest_quoted_distance.location.name) + ")", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("a", null, _toDisplayString(_unref(stats).all.views_abandoned.toLocaleString('en-UK')), 1),
                                        _hoisted_38
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _hoisted_41,
                                        _createVNode(_component_vue_google_heatmap, {
                                            points: _unref(heatmap),
                                            width: '100%',
                                            "initial-zoom": 6,
                                            lat: _unref(heatmap)[0]?.lat,
                                            lng: _unref(heatmap)[0]?.lng
                                        }, null, 8, ["points", "lat", "lng"])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _hoisted_43,
                                            _createVNode(_unref(DoughnutChart), { chartData: suggestedLocationsData.value }, null, 8, ["chartData"])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _createVNode(_unref(DataTable), {
                                        class: "w-full",
                                        options: {
                                            bLengthChange: false,
                                            pageLength: 500,
                                            searching: false,
                                            paging: false,
                                            info: false
                                        }
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_46,
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats).locations, (location, key) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                                        _createElementVNode("td", _hoisted_47, _toDisplayString(location.location.name), 1),
                                                        _createElementVNode("td", {
                                                            class: _normalizeClass(["text-center pt-4", (location.bookings / location.timeslots <= 0.15) ? 'text-red-500' : ''])
                                                        }, _toDisplayString(location.bookings), 3),
                                                        _createElementVNode("td", {
                                                            class: _normalizeClass(["text-center pt-4", (location.bookings / location.timeslots >= 0.75) ? 'text-red-500' : ''])
                                                        }, _toDisplayString(location.timeslots - location.bookings), 3),
                                                        _createElementVNode("td", _hoisted_48, _toDisplayString(location.timeslots), 1),
                                                        _createElementVNode("td", _hoisted_49, _toDisplayString(location.days), 1),
                                                        _createElementVNode("td", _hoisted_50, _toDisplayString(Math.round((location.bookings / location.days) * 100) / 100), 1),
                                                        _createElementVNode("td", _hoisted_51, _toDisplayString(location.views_abandoned), 1),
                                                        _createElementVNode("td", _hoisted_52, _toDisplayString(Math.round(location.average_wait / 60 / 60 / 24)), 1),
                                                        _createElementVNode("td", _hoisted_53, _toDisplayString(Math.round((!isNaN(location.bookings / location.timeslots) ? ((location.bookings / location.timeslots)) : 0) * 100)) + "%", 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                    ]),
                    _: 1
                }),
                _createVNode(ModalDatePicker, {
                    show: datePickModal.value,
                    "onUpdate:show": _cache[3] || (_cache[3] = ($event) => ((datePickModal).value = $event)),
                    starts: _unref(form).starts,
                    "onUpdate:starts": _cache[4] || (_cache[4] = ($event) => ((_unref(form).starts) = $event)),
                    ends: _unref(form).ends,
                    "onUpdate:ends": _cache[5] || (_cache[5] = ($event) => ((_unref(form).ends) = $event)),
                    onConfirm: _unref(fetch)
                }, null, 8, ["show", "starts", "ends", "onConfirm"])
            ], 64));
        };
    }
});
